import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerAdminSettingsPage } from './customer-admin-settings.page';

const routes: Routes = [
  {
    path: '',
    component: CustomerAdminSettingsPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerAdminSettingsPageRoutingModule {}
